export const nonConformityHeaderCellStyle = {
    padding: "13px 14px",
    borderRight: "1px solid #cbd5e1",
    borderBottom: "1px solid #cbd5e1",
    textAlign: "left",
    color: "#0f172a",
    fontSize: "15px",
    fontWeight: 900,
};

export const nonConformityBodyCellStyle = {
    padding: "10px 12px",
    borderRight: "1px solid #cbd5e1",
    borderBottom: "1px solid #e2e8f0",
    verticalAlign: "top",
    color: "#0f172a",
    fontSize: "14px",
    lineHeight: 1.45,
};

export const documentCardStyle = {
    display: "grid",
    gap: "18px",
    padding: "18px",
    background: "white",
    border: "1px solid #cbd5e1",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(15, 23, 42, 0.06)",
};

export const productionControlHeaderCellStyle = {
    padding: "12px 10px",
    borderRight: "1px solid #94a3b8",
    borderBottom: "1px solid #94a3b8",
    textAlign: "center",
    color: "#0f172a",
    fontSize: "14px",
    fontWeight: 900,
    lineHeight: 1.35,
};

export const productionControlBodyCellStyle = {
    padding: "10px",
    borderRight: "1px solid #cbd5e1",
    borderBottom: "1px solid #cbd5e1",
    verticalAlign: "top",
    color: "#0f172a",
    fontSize: "14px",
    lineHeight: 1.45,
};

export const lotReleaseHeaderCellStyle = {
    padding: "13px 14px",
    borderRight: "1px solid #94a3b8",
    borderBottom: "1px solid #94a3b8",
    textAlign: "center",
    color: "#0f172a",
    fontSize: "15px",
    fontWeight: 950,
    lineHeight: 1.35,
};

export const lotReleaseBodyCellStyle = {
    padding: "10px",
    borderRight: "1px solid #cbd5e1",
    borderBottom: "1px solid #cbd5e1",
    verticalAlign: "top",
    color: "#0f172a",
    fontSize: "14px",
    lineHeight: 1.45,
};
